import React, { Component } from 'react';
import { Accordion, Checkbox, Grid, Icon, Popup } from 'semantic-ui-react';

import { MediaInstagram } from '../../../components/share';
import NotesQC from './NotesQC';
import './InstagramPosts.css';

class InstagramPostItem extends Component {
  state = {
    qC: {}
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.props;
    const newIndex = activeIndex === index ? -1 : index;
    this.props.updateActiveIndex(newIndex);
  };

  handleUpdateParent = (newQC) => {
    this.setState({ qC: newQC });
  };
  renderPopupQCOrCheckbox = (qcNumber) => {
    const { qC } = this.state;
    if (qC[qcNumber]) {
      return (
        <Popup
          wide="very"
          trigger={<Checkbox disabled className="qc-checkbox" checked={qC ? qC[qcNumber] : false} />}
          content={
            <small>{qC[`${qcNumber}Fullname`] === '' ? qC[`${qcNumber}Username`] : qC[`${qcNumber}Fullname`]}</small>
          }
        />
      );
    }
    return <Checkbox disabled className="qc-checkbox" />;
  };

  render() {
    const { post, activeIndex, index, subStr } = this.props;

    return (
      <div>
        <Accordion.Title active={activeIndex === index} index={index} onClick={this.handleClick}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={14}>
                <Icon name="dropdown" />{' '}
                {post.caption && post.caption.text ? `${subStr(post.caption.text, 80).trim()}... ` : 'POST '}
              </Grid.Column>
              <Grid.Column width={2} textAlign="right">
                {this.renderPopupQCOrCheckbox('qc1')}
                {this.renderPopupQCOrCheckbox('qc2')}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Title>
        <Accordion.Content active={activeIndex === index}>
          <NotesQC user={this.props.user} onQCUpdate={this.handleUpdateParent} url={post.link} />
          <MediaInstagram key={index} item={post} />
        </Accordion.Content>
      </div>
    );
  }
}

export default InstagramPostItem;



// WEBPACK FOOTER //
// ./src/screens/Compliance/components/InstagramPostItem.js